var _text;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRtgs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 20,
    viewBox: "0 0 48 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _text || (_text = /*#__PURE__*/React.createElement("text", {
    id: "RTGS",
    transform: "translate(0 16)",
    fill: "#474747",
    fontSize: 17,
    fontFamily: "Montserrat-ExtraBoldItalic, Montserrat",
    fontWeight: 800,
    fontStyle: "italic"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "RTGS"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRtgs);
export default __webpack_public_path__ + "static/media/RTGS.9d281d2f5b9ce60af85140fa0423f9dc.svg";
export { ForwardRef as ReactComponent };